// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1OWjh","actionsCol":"EnrolledClinics_actionsCol__1cLxB"};